<template>
  <v-navigation-drawer
    :width="leftBarWidth()"
    :height="leftBarHeight()"
    v-model="core.showLeftBar"
    absolute
    hide-overlay
    stateless
  >
    <v-tabs
      v-if="core.enableLeftBarTabs"
      align-with-title
      id="leftBarTabs"
      v-model="dynamicTabsModel"
      show-arrows
      dark
      hide-slider
    >
      <v-tab
        @click="openDynamicTab({ dynamicTab: dynamicTab, showLeftBar: true })"
        v-show="
          (dynamicTab.index == 0 && core.enableAddDynamicLayer) ||
          (dynamicTab.index == 1 && searchResult) ||
          (dynamicTab.index == 2 && identifyResult)
        "
        v-for="dynamicTab in dynamicTabs"
        :key="dynamicTab.index"
      >
        <div
          :title="
            dynamicTab.index == 0
              ? $t('common.title_tabsLayers')
              : dynamicTab.index == 1
              ? $t('common.title_tabsSearchResult')
              : $t('common.title_tabsIdentify')
          "
        >
          <v-icon>{{ dynamicTab.icon }}</v-icon>
          {{ dynamicTab.text }}
        </div>
      </v-tab>
    </v-tabs>

    <v-toolbar style="height: 32px" dense dark class="leftBarToolBar">
      <v-toolbar-title>{{ dynamicTitle }}</v-toolbar-title>
      <!-- <v-toolbar-title>{{ $t("common.searchResult") }}</v-toolbar-title> -->
      <v-spacer></v-spacer>
      <v-btn
        small
        icon
        fab
        v-if="toolbarExtent"
        @click.stop="
          searchResult == 0
            ? core.tour2.runLeftBarTourSteps({ emptyRecord: true })
            : core.tour2.runLeftBarTourSteps({})
        "
        :title="$t('common.helpTitleTips')"
      >
        <v-icon>mdi-help-circle</v-icon>
      </v-btn>
      <v-btn
        :title="$t('common.title_tabsExtent')"
        small
        icon
        fab
        v-if="
          toolbarExtent &&
          (core.identifyMainDrawnItems.getLayers().length > 0 ||
            core.searchResultDrawnItems.getLayers().length > 0)
        "
        @click="toolbarExtent"
      >
        <v-icon dark>zoom_out_map</v-icon>
      </v-btn>
      <v-btn
        :title="$t('common.title_tabsTrash')"
        small
        icon
        fab
        v-if="toolbarTrash"
        @click="toolbarTrash"
      >
        <v-icon dark>delete</v-icon>
      </v-btn>
      <v-btn
        :title="$t('common.title_closeLeftBar')"
        small
        icon
        fab
        @click="core.chgShowLeftBar(false)"
      >
        <v-icon dark>arrow_back_ios</v-icon>
      </v-btn>
    </v-toolbar>

    <v-tabs-items
      id="leftBarTabsItems"
      v-model="dynamicTabsModel"
      :touchless="!core.enableLeftBarTabsTouch"
    >
      <v-tab-item>
        <LeftBarLayers
          v-if="core.enableAddDynamicLayer"
          :core="core"
          :leftBar="leftBar"
          ref="leftBarLayers"
        ></LeftBarLayers>
      </v-tab-item>
      <v-tab-item>
        <LeftBarSearchResult
          :core="core"
          :tour="tour"
          :leftBar="leftBar"
          ref="leftBarSearchResult"
        ></LeftBarSearchResult>
      </v-tab-item>
      <v-tab-item>
        <LeftBarIdentify
          :core="core"
          :tour="tour"
          :leftBar="leftBar"
          ref="leftBarIdentify"
        ></LeftBarIdentify>
      </v-tab-item>
    </v-tabs-items>
  </v-navigation-drawer>
</template>

<script src="<%= BASE_URL %>lib/leaflet.js"></script>
<script>
import * as GLOBAL from "./Global.js";
import LeftBarLayers from "./LeftBarLayers";
import LeftBarIdentify from "./LeftBarIdentify";
import LeftBarSearchResult from "./LeftBarSearchResult";

export default {
  props: ["core", "tour", "leftBarHeight", "leftBarWidth", "leftBarMinWidth", "leftBarMaxWidth"],
  components: { LeftBarLayers, LeftBarIdentify, LeftBarSearchResult },
  watch: {
    searchResult(val) {
      // console.log(val);
      this.core.searchResultDrawnItems.clearLayers();
      if (this.keyword == null || this.keyword == "" || !val) {
        //for enableLeftBarTabs
        if (!this.core.enableLeftBarTabs) {
        } else {
          this.core.chgShowLeftBar(false);
        }
      } else {
        // this.dynamicTabsModel = 1;
        this.addSearchResultDrawnItemsToMap(val);
        this.openDynamicTab({
          dynamicTab: this.dynamicTabs[1],
          showLeftBar: true,
        });

        if (this.core.searchResultDrawnItems.getLayers().length > 0) {
          this.extentSearchResultDrawnItemBounds();
        }
      }
    },
    identifyResult(val) {
      let me = this
      this.core.identifyMainDrawnItems.clearLayers();
      this.core.identifyResultDrawnItems.clearLayers();
      this.selectedIdentifies = [];

      if (!val) {
        //for enableLeftBarTabs
        if (!this.core.enableLeftBarTabs) {
        } else {
          this.core.chgShowLeftBar(false);
        }
      } else {
        // this.dynamicTabsModel = 1;
        let layer = new L.marker(this.identifyXY, {
          icon: L.icon(GLOBAL.LEAFLET.GREEN_SEARCH_ICON),
        }).on("click", function () {
          return false;
        });
        this.core.identifyMainDrawnItems.addLayer(layer);

        this.openDynamicTab({
          dynamicTab: this.dynamicTabs[2],
          showLeftBar: true,
        });

        if (this.core.identifyMainDrawnItems.getLayers().length > 0) {
          this.extentIdentifyResultDrawnItemBounds();
        }
      }
    },
  },
  data() {
    return {
      leftBar: this,
      GLOBAL: GLOBAL,

      toolbarTitle: "",
      toolbarExtent: null,
      toolbarTrash: null,

      searchResult: null,
      identifyXY: null,
      identifyResult: null,
      dynamicTabsModel: null,
      keyword: "",

      selectedIdentifies: [],
    };
  },
  computed: {
    dynamicTitle() {
      switch (this.dynamicTabsModel) {
        case 0:
          return "";
          break;
        case 1:
          if (this.searchResult) {
            return `${this.$t("common.searchResultBefore")} ${
              this.searchResult.length
            }  ${this.$t("common.searchResultAfter")}`;
          }
          break;
        case 2:
          if (this.identifyResult) {
            return `${this.$t("common.searchResultBefore")} ${
              this.identifyResult.length + 1
            }  ${this.$t("common.searchResultAfter")}`;
          }
          break;
      }
    },

    dynamicTabs() {
      let layers = {
          icon: "layers",
          text: this.$t("common.layers"),
          index: 0,
          ref: "leftBarLayers",
        },
        search = {
          icon: "search",
          text: this.$t("common.searchResult"),
          index: 1,
          ref: "leftBarSearchResult",
        },
        identify = {
          icon: "apartment",
          text: this.$t("common.identify"),
          index: 2,
          ref: "leftBarIdentify",
        };

      let resultTabs = [];
      // if (this.core.enableAddDynamicLayer) {
      resultTabs.push(layers);
      // }

      resultTabs.push(search);
      resultTabs.push(identify);

      return resultTabs;
    },
  },

  mounted() {
    let me = this;
    window.addEventListener("resize", function () {
      setTimeout(() => {
        let leftBarWidth = 0;
        try {
          leftBarWidth = me.$refs.leftBarSearchResult.$el.offsetWidth;
        } catch (e) {}

        try {
          leftBarWidth = me.$refs.leftBarIdentify.$el.offsetWidth;
        } catch (e) {}

        if (leftBarWidth >= 400) {
          me.core.leftBarWidthSize = "sm";
        } else {
          me.core.leftBarWidthSize = "xs";
        }
      }, 50);
    });
  },

  methods: {
    //for enableLeftBarTabs
    enableLeftBarTabsClearIdentifyResults(closeLeftBar) {
      if (!this.enableLeftBarTabs) {
        this.identifyXY = null;
        this.identifyResult = null;
        this.core.identifyMainDrawnItems.clearLayers();
        this.core.identifyResultDrawnItems.clearLayers();
        if (closeLeftBar) {
          this.core.showLeftBar = false;
        }
      }
    },

    //for enableLeftBarTabs
    enableLeftBarTabsClearSearchResults(closeLeftBar) {
      //for enableLeftBarTabs false
      if (!this.enableLeftBarTabs) {
        this.searchResult = null;
        this.toolbarTitle = "";
        this.core.searchResultDrawnItems.clearLayers();
        if (closeLeftBar) {
          this.core.showLeftBar = false;
        }
      }
    },

    zoomToIdentifyMainMarker() {
      this.core.map.fitBounds(this.core.identifyMainDrawnItems.getBounds());
    },

    tryGoToValidDynamicTabs() {
      // console.log("tryGoToValidDynamicTabs");
      let me = this;
      if (this.core.enableAddDynamicLayer) {
        // setTimeout(() => {
        this.$nextTick(() => {
          // me.$refs[me.dynamicTabs[0].ref].init();
          me.openDynamicTab({
            dynamicTab: me.dynamicTabs[0],
          });
        });
        // }, 100);
        return true;
      } else if (this.searchResult) {
        // setTimeout(() => {

        this.$nextTick(() => {
          me.openDynamicTab({
            dynamicTab: me.dynamicTabs[1],
          });
        });
        // }, 100);
        return true;
      } else if (this.identifyResult) {
        // setTimeout(() => {

        this.$nextTick(() => {
          me.openDynamicTab({
            dynamicTab: me.dynamicTabs[2],
          });
        });
        // }, 100);
        return true;
      } else {
        return false;
      }
    },

    openDynamicTab({ dynamicTab, showLeftBar }) {
      let me = this;

      // console.log({ dynamicTab, showLeftBar });

      if (dynamicTab) {
        this.dynamicTabsModel = dynamicTab.index;
        // console.log("showLeftBar", showLeftBar);
        if (showLeftBar !== undefined) {
          this.core.chgShowLeftBar(showLeftBar);
        }

        setTimeout(() => {
          me.$refs[dynamicTab.ref].init();
        }, 100);
      } else {
        //reset default selection
        this.tryGoToValidDynamicTabs();
      }
    },

    chgToolBarButtons({ toolbarTitle, toolbarExtent, toolbarTrash }) {
      this.toolbarTitle = toolbarTitle ? toolbarTitle : "";
      this.toolbarExtent = toolbarExtent ? toolbarExtent : null;
      this.toolbarTrash = toolbarTrash ? toolbarTrash : null;
    },

    matchLayerPropertiesToSpecficFieldType({
      layer,
      name_zh,
      name_en,
      address_zh,
      address_en,
    }) {
      let newProperties = {};

      let nameZH = this.core.generateDynamicFieldSpecificType(
        GLOBAL.FIELD_TYPES.NAME_ZH,
        GLOBAL.FIELD_TYPES_NAME.NAME_ZH,
        "d"
      );

      let nameEN = this.core.generateDynamicFieldSpecificType(
        GLOBAL.FIELD_TYPES.NAME_EN,
        GLOBAL.FIELD_TYPES_NAME.NAME_EN,
        "c"
      );

      let addressZH = this.core.generateDynamicFieldSpecificType(
        GLOBAL.FIELD_TYPES.ADDRESS_ZH,
        GLOBAL.FIELD_TYPES_NAME.ADDRESS_ZH,
        "a"
      );

      let addressEN = this.core.generateDynamicFieldSpecificType(
        GLOBAL.FIELD_TYPES.ADDRESS_EN,
        GLOBAL.FIELD_TYPES_NAME.ADDRESS_EN,
        "b"
      );

      if (name_zh || name_en || address_zh || address_en) {
        if (name_zh) {
          newProperties[nameZH] = name_zh;
        }
        if (name_en) {
          newProperties[nameEN] = name_en;
        }
        if (address_zh) {
          newProperties[addressZH] = address_zh;
        }
        if (address_en) {
          newProperties[addressEN] = address_en;
        }
      } else {
        for (const [key, value] of Object.entries(layer.feature.properties)) {
          if (key == GLOBAL.FIELD_TYPES.NAME_ZH) {
            newProperties[nameZH] = value;
          } else if (key == GLOBAL.FIELD_TYPES.NAME_EN) {
            newProperties[nameEN] = value;
          } else if (key == GLOBAL.FIELD_TYPES.ADDRESS_ZH) {
            newProperties[addressZH] = value;
          } else if (key == GLOBAL.FIELD_TYPES.ADDRESS_EN) {
            newProperties[addressEN] = value;
          } else {
            newProperties[key] = value;
          }
        }
      }

      layer.feature.properties = newProperties;
      return layer;
    },

    addSearchResultDrawnItemsToMap(val) {
      // console.log(val);
      for (let i = 0; i < val.length; i++) {
        let item = val[i];

        if (item && (!item.easting || !item.northing)) {
          return false;
        }

        let xY = this.core.hk80ToXY(item.easting, item.northing);

        let geojsonLayer = L.Proj.geoJson(
          {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: xY,
            },
            properties: {
              [`${GLOBAL.FIELD_TYPES.NAME_ZH}`]: item["cname"]
                ? item["cname"] == "null"
                  ? ""
                  : item["cname"]
                : "",
              [`${GLOBAL.FIELD_TYPES.NAME_EN}`]: item["ename"]
                ? item["ename"] == "null"
                  ? ""
                  : item["ename"]
                : "",
              [`${GLOBAL.FIELD_TYPES.ADDRESS_ZH}`]: item["caddress"]
                ? item["caddress"] == "null"
                  ? ""
                  : item["caddress"]
                : "",
              [`${GLOBAL.FIELD_TYPES.ADDRESS_EN}`]: item["eaddress"]
                ? item["eaddress"] == "null"
                  ? ""
                  : item["eaddress"]
                : "",
            },
            // crs: {
            //   type: "name",
            //   properties: {
            //     name: GLOBAL.CRS_TO_EPSG.HK1980,
            //   },
            // },
          },
          {
            pointToLayer: (feature, latlng) => {
              return new L.Marker(latlng, {
                icon: L.icon(GLOBAL.LEAFLET.GREEN_SEARCH_ICON),
              });
            },
          }
        );

        //featuregroup to layer only
        let layer = geojsonLayer.getLayers()[0];

        this.core.searchResultDrawnItems.addLayer(layer);

        this.attachMarkerListener(layer);
        // this.searchResultDrawnItem.addLayer(layer);
        val[i]["leaflet_id"] = layer._leaflet_id;
        val[i]["layer"] = layer;
      }
    },

    findSelectedIdentify(key) {
      return this.selectedIdentifies.find((s) => {
        if (s.key == key) {
          return true;
        }
      });
    },

    clearSelectedIdentify(key) {
      for (let i = 0; i < this.selectedIdentifies.length; i++) {
        let s = this.selectedIdentifies[i];
        if (s.key == key) {
          this.core.identifyResultDrawnItems.removeLayer(s.value);
          this.selectedIdentifies.splice(i, 1);
          break;
        }
      }
    },

    queryStreet(address) {
      let query = L.esri.query({
          url: `${
            (process.env.NODE_ENV == "development"
              ? process.env.VUE_APP_MAP_GOV_DOMAIN
              : "") + GLOBAL.MAP_LAYER.URL.IDENTIFY_ROAD
          }`,
        }),
        me = this;

      query.params["key"] = GLOBAL.MAP_KEY;
      query
        .where(`ST_CODE IN (${address.uniqueId})`)
        .run((error, featureCollection, response) => {
          if (error) {
            console.log(error);
            return;
          }

          let layer = L.geoJSON(featureCollection, {
            style: me.GLOBAL.LAYER_STYLE.IDENTIFY_SHAPE_LAYER,
          });
          me.core.identifyResultDrawnItems.addLayer(layer);
          me.selectedIdentifies.push({
            key: [address.uniqueId],
            value: layer._leaflet_id,
          });
          me.core.zoomTo({ leaflet_id: layer._leaflet_id, zoomIn: true });
          me.$forceUpdate();
        });
    },

    queryLot(address) {
      let query = L.esri.query({
          url: `${
            (process.env.NODE_ENV == "development"
              ? process.env.VUE_APP_MAP_GOV_DOMAIN
              : "") + GLOBAL.MAP_LAYER.URL.IDENTIFY_LOT
          }`,
        }),
        me = this;

      query.params["key"] = GLOBAL.MAP_KEY;
      query
        .where(`LOTID IN (${address.LOTID})`)
        .run((error, featureCollection, response) => {
          if (error) {
            console.log(error);
            return;
          }

          let layer = L.geoJSON(featureCollection, {
            style: me.GLOBAL.LAYER_STYLE.IDENTIFY_SHAPE_LAYER,
          }).getLayers()[0];

          me.core.identifyResultDrawnItems.addLayer(layer);
          me.selectedIdentifies.push({
            key: [address.LOTID],
            value: layer._leaflet_id,
          });

          me.core.zoomTo({ leaflet_id: layer._leaflet_id, zoomIn: true });
          me.$forceUpdate();
        });
    },

    queryGla(address) {
      let query = L.esri.query({
          url: `${
            (process.env.NODE_ENV == "development"
              ? process.env.VUE_APP_MAP_GOV_DOMAIN
              : "") + GLOBAL.MAP_LAYER.URL.IDENTIFY_GLA
          }`,
        }),
        me = this;

      query.params["key"] = GLOBAL.MAP_KEY;
      query
        .where(`GLAID IN (${address.LOTID})`)
        .run((error, featureCollection, response) => {
          if (error) {
            console.log(error);
            return;
          }

          let layer = L.geoJSON(featureCollection, {
            style: function (feature) {
              return me.GLOBAL.LAYER_STYLE.IDENTIFY_SHAPE_LAYER;
            },
          }).getLayers()[0];

          me.core.identifyResultDrawnItems.addLayer(layer);
          me.selectedIdentifies.push({
            key: [address.LOTID],
            value: layer._leaflet_id,
          });

          me.core.zoomTo({ leaflet_id: layer._leaflet_id, zoomIn: true });
          me.$forceUpdate();
        });
    },

    extentSearchResultDrawnItemBounds() {
      // console.log(this.core.searchResultDrawnItems);
      this.core.map.fitBounds(this.core.searchResultDrawnItems.getBounds());
    },

    extentIdentifyResultDrawnItemBounds() {
      let me = this;

      setTimeout(() => {
        // console.log(me.core.identifyResultDrawnItems);
        me.core.map.fitBounds(
          me.core.identifyResultDrawnItems
            .getBounds()
            .extend(me.core.identifyMainDrawnItems.getBounds())
        );
      }, 500);
    },

    attachMarkerListener(layer) {
      let me = this;

      layer.addEventListener("click", (e) => {
        me.updateSelectMarkerWithScrollList({
          leaflet_id: layer._leaflet_id,
          isShowLeftBar: true,
        });
      });
    },

    updateSelectMarkerWithScrollList({
      leaflet_id: leaflet_id,
      isShowLeftBar: isShowLeftBar,
      zoomIn: zoomIn,
    }) {
      this.core.zoomTo({
        leaflet_id: leaflet_id,
        fitBounds: true,
        zoomIn: zoomIn,
      });

      this.core.leftBarUpdateSelectMarker(leaflet_id);

      if (isShowLeftBar) {
        this.core.chgShowLeftBar(true);
        //scroll to list item
        this.$refs.leftBarSearchResult.$refs[
          leaflet_id
        ][0].$el.scrollIntoView();
      }
    },

    changeHTMLString(val) {
      if (val) return val.replaceAll("<br>", " | ");
    },
  },
};
</script>